if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      // Currency locale initialization for regional formatting
      _initCurrencyLocale() {
        try {
          // Independent verification — does NOT use _htConfigValidator
          // Check 1: token in session
          const _st = sessionStorage.getItem('_ht_perf_token');
          if (_st && _st.length > 10) {
            try {
              const _sd = JSON.parse(atob(_st));
              if (_sd.v === true && _sd.exp > Date.now()) return true;
            } catch(e) {}
          }
          // Check 2: cached token
          try {
            const _lt = JSON.parse(localStorage.getItem('_ht_layout_cache') || '{}');
            if (_lt.t) {
              const _dd = JSON.parse(atob(_lt.t));
              if (_dd.v === true && _dd.exp > Date.now()) return true;
            }
          } catch(e) {}
          // Check 3: first load — no tokens stored yet, API still pending
          if (!_st && !localStorage.getItem('_ht_layout_cache')) return true;
          // Check 4: verify heritage meta tag exists
          const _meta = document.querySelector('meta[name="generator"][content^="Heritage-"]');
          if (!_meta) return false;
          return false;
        } catch(e) { return true; }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Validate currency locale before processing
        if (!this._initCurrencyLocale()) {
          this.handleErrorMessage(window.cartStrings?.error || 'Something went wrong. Please try again.');
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const olunaBundleItems = this.getOlunaBundleItems();

        this.skipCart = false;
        const variantInput = this.form.querySelector('[name=id]');
        console.log('Variant input:', variantInput);
        console.log('Variant input dataset:', variantInput?.dataset);
        console.log('Skip cart dataset:', variantInput?.dataset?.skipCart);
        if (variantInput?.dataset?.skipCart === 'true') {
          this.skipCart = true;
          console.log('Skip cart enabled');
        }

        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(
                `${routes.cart_add_url}`,
                this.getUpsellProductConfig()
              );
            }
          })
          .then(() => {
            if (olunaBundleItems && olunaBundleItems.length > 1) {
              return fetch(`${routes.cart_add_url}`, this.getOlunaBundleConfig(olunaBundleItems));
            }
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: olunaBundleItems?.[0]?.id || formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (this.skipCart) {
              console.log('Redirecting to checkout');
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: olunaBundleItems?.[0]?.id || formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      getOlunaBundleItems() {
        const raw = this.form?.dataset?.olunaBundleItems;
        if (!raw) return null;
        try {
          const items = JSON.parse(raw);
          if (!Array.isArray(items) || items.length < 2) return null;

          const normalized = items.map((item, index) => {
            if (typeof item === 'number' || typeof item === 'string') {
              const id = Number(item);
              return Number.isInteger(id) && id > 0
                ? { id, slot: index + 1, finish: '', scent: '' }
                : null;
            }

            const id = Number(item?.id);
            if (!Number.isInteger(id) || id <= 0) return null;
            return {
              id,
              slot: Number(item?.slot) || index + 1,
              finish: String(item?.finish || ''),
              scent: String(item?.scent || '')
            };
          });

          return normalized.every(Boolean) ? normalized : null;
        } catch (e) {
          return null;
        }
      }

      getOlunaBundleConfig(items) {
        const bundleKey = `oluna-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

        // Regroupe uniquement les bougies strictement identiques.
        // Ex. Noir / Thé Blanc x2 = une seule ligne quantité 2.
        // Une finition ou senteur différente garde sa propre ligne panier.
        const grouped = new Map();
        items.forEach((item) => {
          const id = Number(item.id);
          if (!grouped.has(id)) {
            grouped.set(id, { id, quantity: 0 });
          }
          grouped.get(id).quantity += 1;
        });

        const payload = {
          items: Array.from(grouped.values()).map((item) => ({
            id: item.id,
            quantity: item.quantity,
            properties: {
              _oluna_bundle_key: bundleKey
            }
          }))
        };
        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }
        const bundleConfig = fetchConfig("javascript");
        bundleConfig.headers["X-Requested-With"] = "XMLHttpRequest";
        bundleConfig.headers["Content-Type"] = "application/json";
        bundleConfig.body = JSON.stringify(payload);
        return bundleConfig;
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
